import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { svgMap } from 'core/utils/slugMaps';
import { getColor } from 'core/utils';
import {
	StyledSvgHeader,
	StyledDescriptionWrapper,
	StyledDescription,
	ViewAllLink,
} from './subNavStyles';

class SvgHeader extends PureComponent {
	render() {
		const { href, imageTitle, slug, accentColor } = this.props;
		const SvgComponent = slug in svgMap ? svgMap[slug] : svgMap[slug.split("/").shift()];

		return (
			<StyledSvgHeader href={href} accentColor={accentColor}>
				<StyledDescriptionWrapper>
					{SvgComponent && (<SvgComponent width={60} height={67} />)}
					<StyledDescription fontSize={16} marginLeft={20}>{imageTitle}</StyledDescription>
				</StyledDescriptionWrapper>
				<ViewAllLink>View All</ViewAllLink>
			</StyledSvgHeader>
		);
	}

	static propTypes = {
		imageTitle: PropTypes.string.isRequired,
		href: PropTypes.string.isRequired,
		slug: PropTypes.string.isRequired,
		accentColor: PropTypes.string,
	};

	static defaultProps = {
		accentColor: getColor("darkTeal"),
	};
}

export default SvgHeader;
